export const blockIconsAndroidBatteryFullNew = (
	<span className='material-symbols-outlined'>battery_full</span>
);
